import { RootState } from "../../../core/store";
import { ACTIVITY_REPORT, TActivityReportSliceState, TReportRequestParams } from "../types/downloadTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: TActivityReportSliceState = {
    activityReportData: null,
    activityReportLoading: false,
    activityReportError: null,
};

const activityReportSlice = createSlice({
    name: ACTIVITY_REPORT,
    initialState,
    reducers: {
        submitActivityReportRequestAction: (state: TActivityReportSliceState, _: PayloadAction<TReportRequestParams>) => {
            state.activityReportLoading = true;
            state.activityReportError = null;
            state.activityReportData = null;
        },
        submitActivityReportSuccessAction: (state: TActivityReportSliceState, { payload: data }: PayloadAction<any>) => {
            state.activityReportLoading = false;
            state.activityReportData = data;
            state.activityReportError = null;
        },
        submitActivityReportErrorAction: (state: TActivityReportSliceState, { payload: error }: PayloadAction<any>) => {
            state.activityReportLoading = false;
            state.activityReportData = null;
            state.activityReportError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
        clearActivityReportStateAction: (state: TActivityReportSliceState) => {
            state.activityReportLoading = false;
            state.activityReportData = null;
            state.activityReportError = null;
        },
    },
});

export const activityReportActions = {
    ...activityReportSlice.actions
};

export default activityReportSlice.reducer;

export const selectActivityReportData = (state: RootState) =>
    state.activityReportSlice.activityReportData;
export const selectActivityReportLoading = (state: RootState) =>
    state.activityReportSlice.activityReportLoading;
export const selectActivityReportError = (state: RootState) =>
    state.activityReportSlice.activityReportError;
